import { CommonModule }     from '@angular/common';
import { NgModule }         from '@angular/core';
import { GroupModule }      from '@shared/components/group/group.module';
import { TableComponent }   from '@shared/components/table/table.component';
import { DirectivesModule } from '@shared/directives/directives.module';


@NgModule( {
	declarations: [
		TableComponent
	],
	imports: [
		CommonModule,
		DirectivesModule,
		GroupModule
	],
	exports: [
		TableComponent
	]
} )
export class TableModule {}
